<template>
  <div id="chart">
    <apexchart
      type="rangeBar"
      height="200"
      :options="chartOptions"
      :series="getSeries()"
      v-if="shiftStartTime && shiftEndTime"
    ></apexchart>
  </div>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
import moment from 'moment';
export default {
  name: "StaffAttendanceCategoryTimeBar",
  components: {
    apexchart: VueApexCharts,
  },
  props: ["shiftStartTime", "shiftEndTime", "bufferTime","allowedTimeBeforeLateMark","minimumOvertime"],
  data() {
    return {
      chartOptions: {
        chart: {
          height: 350,
          type: "rangeBar",
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: "30%",
            rangeBarGroupRows: true,
          },
        },
        colors: [
          "#008FFB",
          "#00E396",
          "#FEB019",
          "#FF4560",
          "#775DD0",
          "#3F51B5",
          "#546E7A",
          "#D4526E",
          "#8D5B4C",
          "#F86624",
          "#D7263D",
          "#1B998B",
          "#2E294E",
          "#F46036",
          "#E2C044",
        ],
        fill: {
          type: "solid",
        },
        xaxis: {
          type: "datetime",
          labels: {
              datetimeUTC: false
          }
        },

        legend: {
          position: "right",
        },
           tooltip: {
              custom: function(opts) {
                // const fromYear = new Date(opts.y1).getFullYear()
                // const toYear = new Date(opts.y2).getFullYear()
                // const values = opts.ctx.rangeBar.getTooltipValues(opts)
                // console.log(opts.y1)
                return `${moment(opts.y1).format('hh:mm a')} - ${moment(opts.y2).format('hh:mm a')}`
              }
            },
      },
    };
  },
  methods: {
    getSeries() {
        var shiftStartTime = this.setTimeToNewDate(this.shiftStartTime);
        var shiftEndTime = this.setTimeToNewDate(this.shiftEndTime);
        var startBufferEndTime = moment(shiftStartTime).add(this.bufferTime.split(':')[0], 'h').add(this.bufferTime.split(':')[1], 'm').toDate();
        var endBufferEndTime = moment(shiftEndTime).subtract(this.bufferTime.split(':')[0], 'h').subtract(this.bufferTime.split(':')[1], 'm').toDate();
        var allowedTimeBeforeLateMarkTime = moment(shiftStartTime).add(this.allowedTimeBeforeLateMark,'h:m').toDate();
        var minimumOTTime = moment(shiftEndTime).add(this.minimumOvertime,'h:m').toDate();

      var series = [
        // George Washington
        {
          name: "Shift Time",
          data: [
            {
              x: "Shift Time",
              y: [
                shiftStartTime.getTime(),
                this.setTimeToNewDate(this.shiftEndTime).getTime(),
              ],
            },
            
          ],
        },
        {
          name: "Entry Buffer Time",
          data: [
            {
              x: "Buffer Time",
              y: [
                this.setTimeToNewDate(this.shiftStartTime).getTime(),
                startBufferEndTime.getTime(),
              ],
            },
            
          ],
        },
        {
          name: "Exit Buffer Time",
          data: [
            {
              x: "Buffer Time",
              y: [
                endBufferEndTime.getTime(),
                this.setTimeToNewDate(this.shiftEndTime).getTime(),

              ],
            },
            
          ],
        },
        {
          name: "Allowed Time Before Late Mark",
          data: [
            {
              x: "Late mark time",
              y: [
                this.setTimeToNewDate(this.shiftStartTime).getTime(),
                allowedTimeBeforeLateMarkTime.getTime(),

              ],
            },
            
          ],
        },
        {
          name: "Minimum Overtime",
          data: [
            {
              x: "Minimum Overtime Time",
              y: [
                this.setTimeToNewDate(this.shiftEndTime).getTime(),
                minimumOTTime.getTime(),
              ],
            },
            
          ],
        },
      ];
      return series;
    },
    setTimeToNewDate(timeString) {
      var d = new Date();
      d.setHours(timeString.split(":")[0]);
      d.setMinutes(timeString.split(":")[1]);
      return d;
    },
  },
};
</script>